import { FieldError } from '@launchpad-ui/components';

type FormFieldErrorProps = {
  meta: {
    isTouched: boolean;
    isDirty: boolean;
    errors: Error[];
  };
};

export function FormFieldError({ meta }: FormFieldErrorProps) {
  if (meta.isTouched && meta.isDirty && meta.errors.length > 0) {
    return (
      <FieldError>
        {meta.errors
          .flat()
          .map((error: Error) => error.message)
          .join('. ')}
      </FieldError>
    );
  }
}
